import React from "react";
import { loginBack } from "helper/constant";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import AuthActions from "redux/auth/actions";
import storeActions from "redux/storeID/actions";
import enhancer from "./enhancer/LoginFormEnhancer";
import Api from "api/Api";
import { useState } from "react";
import Toaster from "components/common/Toaster";
import { useRef } from "react";
import Button from "components/button/Button";

const { login } = AuthActions;
const { setStoreId, setIsStore } = storeActions;

const Login = props => {
  const toaster = useRef();
  const [loading, setLoading] = useState(false);

  const handleLogin = e => {
    e.preventDefault();
    let { values, handleSubmit, isValid } = props;
    if (isValid) {
      setLoading(true);
      Api.post("/admin/login", {
        email: values.email,
        password: values.password
      })
        .then(res => {
          if (res.data.status) {
            const data = res.data.data;
            localStorage.setItem("isLogin", true);
            localStorage.setItem("Authorization", data.accessToken);
            localStorage.setItem("adminType", data.adminType || "");
            localStorage.setItem("primaryColor", data.primaryColor || "");
            localStorage.setItem("secondaryColor", data.secondaryColor || "");
            localStorage.setItem("sidebarColor", data.sidebarColor || "");
            localStorage.setItem("topbarColor", data.topbarColor || "");
            localStorage.setItem(
              "menuHighlightColor",
              data.menuHighlightColor || ""
            );
            localStorage.setItem("menuTextColor", data.menuTextColor || "");
            localStorage.setItem("accentColor", data.accentColor || "");
            props.login({
              token: data.accessToken,
              adminType: data.adminType,
              storesId: data.storesId,
              storeName: data.storeName,
              storeLogo: data.storeLogo,
              primaryColor: data.primaryColor,
              secondaryColor: data.secondaryColor,
              sidebarColor: data.sidebarColor,
              topbarColor: data.topbarColor,
              menuHighlightColor: data.menuHighlightColor,
              menuTextColor: data.menuTextColor,
              accentColor: data.accentColor
            });
            setLoading(false);

            // If STORE admin, set store context and redirect to store dashboard
            if (data.adminType === "STORE" && data.storesId) {
              props.setStoreId({ id: data.storesId, name: data.storeName });
              props.setIsStore(true);
              props.history.push("/store/dashboard");
            } else {
              props.history.push("/dashboard");
            }
          } else {
            setLoading(false);
            toaster.current.error(res.data.message);
          }
        })
        .catch(error => {
          if (toaster.current)
            toaster.current.error(error.response.data.message);
          setLoading(false);
        });
    }

    handleSubmit();
  };

  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount
  } = props;

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  return (
    <div className="login-split-container">
      <div className="login-card">
        {/* Left Panel - Image with green overlay + curved edge */}
        <div className="login-left-panel">
          <img src={loginBack} alt="" className="login-left-img" />
          <div className="login-left-overlay"></div>
          <svg
            className="login-curve"
            viewBox="0 0 100 800"
            preserveAspectRatio="none"
          >
            <path
              d="M100,0 L100,800 L0,800 C30,600 70,500 30,400 C-10,300 40,150 100,0 Z"
              fill="#ffffff"
            />
          </svg>
        </div>

        {/* Right Panel - Login Form */}
        <div className="login-right-panel">
          <div className="login-form-wrapper">
            <h2 className="login-welcome-title">Welcome</h2>
            <p className="login-welcome-subtitle">
              Log in to your account to continue
            </p>

            <form onSubmit={handleLogin}>
              <div className="login-field-group">
                <div className="login-input-wrapper">
                  <i className="fas fa-user login-input-icon"></i>
                  <input
                    type="email"
                    className="login-input"
                    id="email"
                    onChange={handleChange}
                    value={values.email}
                    onBlur={handleBlur}
                    placeholder="awesome@user.com"
                  />
                </div>
                <Error field="email" />
              </div>

              <div className="login-field-group">
                <div className="login-input-wrapper">
                  <i className="fas fa-lock login-input-icon"></i>
                  <input
                    type="password"
                    className="login-input"
                    id="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="••••••••••••"
                  />
                </div>
                <Error field="password" />
              </div>

              <div className="login-btn-wrap">
                <Button
                  type="submit"
                  loading={loading}
                  disabled={loading}
                  className="c-btn login-submit-btn"
                  dataStyle="expand-right"
                >
                  Log In
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Toaster ref={toaster} />
    </div>
  );
};

export default compose(
  withRouter,
  enhancer,
  connect(null, { login, setStoreId, setIsStore })
)(Login);
